import { ApiProperty } from '@nestjs/swagger';

export class AssetModelReq {
    @ApiProperty()
    assetCategory?:string[]
}